import styled, { css } from 'styled-components';
import twTheme from '../../styles/theme';

export const MainFooter = styled.footer<{ hideOnDesktop?: boolean }>`
  background-color: ${twTheme.colour.forest};
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    ${(props) =>
      props.hideOnDesktop
        ? css`
            display: none;
          `
        : ''}
  }
  color: ${twTheme.colour.white};
  position: relative;
  @media print {
    display: none;
  }
`;

export const FooterWrapper = styled.div`
  max-width: ${twTheme.screens.maxViewport};
  margin: auto;
  position: relative;
  padding: 56px;
  @media screen and (min-width: ${twTheme.screens.tablet}) {
    padding: 56px 56px 32px;
  }
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    padding: 120px 60px 40px 60px;
  }
  .sr-only {
    color: ${twTheme.colour.white};
  }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 48px;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    gap: 20px;
    flex-direction: row;
  }
`;

// First Column Components
export const FirstColumn = styled.nav`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    width: 40%;
    gap: 40px;
    align-items: flex-start;
  }
`;

export const LogoStyle = styled.div`
  max-width: 200px;
  margin: auto;
  width: 100%;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    max-width: 314px;
    margin: 0 0 0 -12px;
  }
  a {
    display: block;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
  text-align: center;
  max-width: 314px;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    flex-direction: row;
    max-width: none;
    text-align: left;
    gap: 40px;
  }
`;

export const TextLinkStyle = styled.div`
  @media screen and (max-width: ${twTheme.screens.desktop}) {
    &.office-address {
      gap: 6px;
      h2.title {
        margin-bottom: 4px;
        font-size: 14px;
      }
    }
  }
  ${twTheme.fontStyle.desktop.caption}
  display: flex;
  flex-direction: column;
  gap: 10px;
  white-space: nowrap;
  a {
    color: ${twTheme.colour.lilac};
    font-size: 14px;
    font-weight: 400;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
  h2.title {
    font-size: 14px;
    font-weight: 600;
  }
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    font-weight: 400;
  }
`;

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    margin-top: 12px;
    gap: 20px;
    justify-content: flex-start;
  }
`;

export const SocialIconsLinksStyle = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 12px;
  a {
    width: 24px;
    height: 24px;
    @media screen and (min-width: ${twTheme.screens.desktop}) {
      width: 32px;
      height: 32px;
    }
    * {
      fill: ${twTheme.colour.white};
    }
  }
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    margin-bottom: 2px;
    justify-content: left;
    margin-top: 0;
  }
`;

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 10px;
  text-align: right;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    gap: 12px;
    flex-direction: row;
  }
`;

export const CopyrightTextStyle = styled.span`
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.6px;
  font-family: Roboto;
  text-align: left;
  white-space: nowrap;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    display: block;
    margin: 0;
  }
`;

export const LegalLinkStyle = styled.div`
  @media screen and (max-width: 369px) {
    flex-direction: column;
    align-items: center;
  }
  ${twTheme.fontStyle.desktop.caption}
  font-weight: 600;
  display: flex;
  flex-direction: row;
  gap: 10px;
  text-align: left;
  white-space: nowrap;
  a {
    color: ${twTheme.colour.lilac};
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
  }
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    font-weight: 400;
  }
  p {
    font-size: 14px;
    font-weight: 400;
  }
`;

// Second Column Components
export const SecondColumn = styled.div`
  display: none;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    display: flex;
    flex-direction: column;
    width: 60%;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
`;

export const NavigationTextStyle = styled.div`
  ${twTheme.fontStyle.desktop.heading6}
  display: none;
  @media screen and (min-width: ${twTheme.screens.desktop}) {
    display: block;
    text-align: right;
  }
`;
